/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroupOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m17.771 19.186 4.522 4.521 1.414-1.414-9.187-9.187-1.429-1.43-2.768-2.767-1.429-1.43-2.086-2.085-1.421-1.422-3.68-3.68L.293 1.708l3.941 3.941A3.993 3.993 0 0 0 4 7a3.99 3.99 0 0 0 1.333 2.981l1.334-1.49a1.996 1.996 0 0 1-.612-1.022l1.982 1.982a4 4 0 0 0 4.511 4.511l1.234 1.235A7.7 7.7 0 0 0 12 15c-2.013 0-3.565.658-4.596 1.852C6.394 18.02 6 19.569 6 21.142V22h2v-.857c0-1.269.32-2.292.918-2.984C9.494 17.492 10.442 17 12 17s2.507.492 3.083 1.16c.597.691.917 1.714.917 2.983V22h2v-.857c0-.666-.07-1.327-.229-1.957zM22 18.077v.811l-2.134-2.133c-.123-.563-.33-1.05-.614-1.446-.43-.6-1.09-1.07-2.101-1.27l-.26-.26.247-1.77c1.664.232 2.92.991 3.74 2.135C21.68 15.262 22 16.657 22 18.077zM16 10c0 .82-.247 1.583-.67 2.218l-1.473-1.473a2 2 0 0 0-2.601-2.602L9.781 6.67A4 4 0 0 1 16 10zM9.333 5.509a1.988 1.988 0 0 0-1.218-.506L6.431 3.32A3.987 3.987 0 0 1 8 3c1.024 0 1.96.386 2.667 1.019zM18.236 7a2 2 0 0 0-3.49-1.333l-1.491-1.334a4 4 0 1 1 5.333 5.903l-1.177-1.617c.502-.366.825-.955.825-1.619z" />
        <path d="M4 18.077c0-1.141.26-2.087.747-2.768.47-.656 1.215-1.155 2.39-1.319l-.275-1.98c-1.665.231-2.92.99-3.74 2.134C2.32 15.262 2 16.657 2 18.077v.857h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgPeopleGroupOff as PeopleGroupOff };
